/**
 * ResourceMediaService
 * Admin backfill for Resource Centre streaming media: links existing session
 * and step URLs to FileManagement records, then queues them for HLS,
 * transcript and audio processing through the throttled drip.
 * Route: api/resource-media
 */
import { BaseService } from '../base/BaseService';
export class ResourceMediaService extends BaseService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? ResourceMediaService.DEFAULT_SERVICE_PATH,
            basePath: ResourceMediaService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    /**
     * Link sessions / steps to FileRecords by storage key (registering bucket
     * objects that have none). With `dryRun` (the default) nothing is written
     * and the report says what would happen.
     * POST api/resource-media/backfill/link?dryRun=
     */
    async backfillLink(dryRun = true) {
        const response = await this.backfillLinkRaw(dryRun);
        return response.data ?? null;
    }
    backfillLinkRaw(dryRun = true) {
        return this.http.post(this.buildUrl(`backfill/link?dryRun=${dryRun ? 'true' : 'false'}`), {});
    }
    /**
     * Queue linked media that is not processed (or failed) for the drip.
     * POST api/resource-media/backfill/queue
     */
    async backfillQueue() {
        const response = await this.backfillQueueRaw();
        return response.data ?? null;
    }
    backfillQueueRaw() {
        return this.http.post(this.buildUrl('backfill/queue'), {});
    }
    /**
     * Counts by media status plus the drip queue length.
     * GET api/resource-media/backfill/status
     */
    async backfillStatus() {
        const response = await this.backfillStatusRaw();
        return response.data ?? null;
    }
    backfillStatusRaw() {
        return this.http.get(this.buildUrl('backfill/status'));
    }
}
ResourceMediaService.DEFAULT_SERVICE_PATH = 'resources';
ResourceMediaService.BASE_PATH = 'api/resource-media';
//# sourceMappingURL=ResourceMediaService.js.map